<template>
    <div class='h100vh-100'>
        <CustomCounterBar ref="CustomCounterBar" :gnbCounterTreeClickInfo="gnbCounterTreeClickInfo"></CustomCounterBar>
        <CustomCounterList ref="CustomCounterList" :gnbCounterTreeClickInfo="gnbCounterTreeClickInfo"></CustomCounterList>

        <!-- 新增自定义指标 -->
        <CustomDialog ref='CreateCustomCounterDialog' :element='createCustomCounterDialog.element' :styles='createCustomCounterDialog.style'>
            <template v-slot:dialog-content>
                <CreateCustomCounterDialog ref='createCustomCounterDialog' :gnbCounterTreeClickInfo="gnbCounterTreeClickInfo"></CreateCustomCounterDialog>
            </template>
        </CustomDialog>

        <!-- 修改自定义指标 -->
        <CustomDialog ref='ModifyCustomCounterDialog' :element='modifyCustomCounterDialog.element' :styles='modifyCustomCounterDialog.style'>
            <template v-slot:dialog-content>
                <ModifyCustomCounterDialog ref='modifyCustomCounterDialog' :gnbCounterTreeClickInfo="gnbCounterTreeClickInfo"></ModifyCustomCounterDialog>
            </template>
        </CustomDialog>
    </div>
</template>

<script>
    import CustomDialog from "../../../../common/CustomDialog";
    import CustomCounterBar from "./CustomCounterBar";
    import CustomCounterList from "./CustomCounterList";
    import CreateCustomCounterDialog from "./dialog/CreateCustomCounterDialog";
    import ModifyCustomCounterDialog from "./dialog/ModifyCustomCounterDialog";
    import {EventBus} from "../../../../../plugins/eventBus";

    export default {
        name: 'CustomCounter',

        components: {
            CustomDialog,
            CustomCounterBar,
            CustomCounterList,
            CreateCustomCounterDialog,
            ModifyCustomCounterDialog
        },

        props: [
            'gnbCounterTreeClickInfo'
        ],

        data() {
            return {
                createCustomCounterDialog: {
                    style: {
                        width: '800px',
                        height: 'auto',
                        visible: false,
                        model: true
                    },
                    element: {
                        title: this.$t('Pm.addCustomCounter'),
                        target: this.$refs.CustomCounterList,
                        refName: 'createCustomCounterElement',
                        buttonGroup: [
                            { click: this.closeCreateCustomCounterDialog, buttonModel: { content: this.$t('Common.cancel') } },
                            { click: this.createCustomCounter, buttonModel: { content: this.$t('Pm.finish'), isPrimary: true } }
                        ],
                        isClose: true
                    }
                },

                modifyCustomCounterDialog: {
                    style: {
                        width: '800px',
                        height: 'auto',
                        visible: false,
                        model: true
                    },
                    element: {
                        title: this.$t('Pm.modCustomCounter'),
                        target: this.$refs.CustomCounterList,
                        refName: 'modifyCustomCounterElement',
                        buttonGroup: [
                            { click: this.closeModifyCustomCounterDialog, buttonModel: { content: this.$t('Common.cancel') } },
                            { click: this.modifyCustomCounter, buttonModel: { content: this.$t('Pm.finish'), isPrimary: true } }
                        ],
                        isClose: true
                    }
                },
            };
        },

        methods: {
            methodList(operator) {
                switch (operator) {
                    case 'create':
                        this.createTask();
                        break;
                    case 'modify':
                        this.modifyTask();
                        break;
                    case 'delete':
                        this.deleteTask();
                        break;
                    default:
                }
            },

            createTask(){
                this.$refs.createCustomCounterDialog.getCounterList();
                this.$refs.CreateCustomCounterDialog.show();
                this.$refs.createCustomCounterDialog.bindValidateOfCreateCustomCounter();
            },

            modifyTask(){
                let data = this.$refs.CustomCounterList.rowDataOfCustomCounter;
                console.log('modifyData',data);

                if(data == null || data == ''){
                    EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
                    return;
                }
                this.$refs.modifyCustomCounterDialog.counterNameCH = data.counterNameCH;
                this.$refs.modifyCustomCounterDialog.counterNameEN = data.counterNameEN;
                this.$refs.modifyCustomCounterDialog.unit = data.unit;
                this.$refs.modifyCustomCounterDialog.spaceCode = data.spaceCode;
                this.$refs.modifyCustomCounterDialog.paramTypeCode = data.paramTypeCode;
                this.$refs.modifyCustomCounterDialog.counterCode = data.counterCode;
                this.$refs.modifyCustomCounterDialog.getCounterList();
                this.$refs.ModifyCustomCounterDialog.show();
                this.$refs.modifyCustomCounterDialog.bindValidateOfModifyCustomCounter();
            },

            deleteTask(){
                let data = this.$refs.CustomCounterList.rowDataOfCustomCounter;

                if(data == null || data == ''){
                    EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
                    return;
                }

                this.$loading.showLoadding(this.$t('System.loading'));
                this.$axios.post('/lte/ems/pm/gnb/counter/deleteCustomCounter.html', {
                    paramTypeCode: data.paramTypeCode,
                    spaceCode: data.spaceCode,
                    counterCode: data.counterCode,
                }).then(response => {
                    console.log(response)
                    if(response && response.status == 200 && response.data == 1){
                        EventBus.$emit('toast', {type: 'success', content: `${this.$t('Pm.delCustomCounter')}${this.$t('Pm.success')}`});
                    }else{
                        EventBus.$emit('toast', {type: 'success', content: `${this.$t('Pm.delCustomCounter')}${this.$t('Pm.fail')}`});
                    }
                    this.$refs.CustomCounterList.getCustomCounterList();
                    this.$loading.hideLoadding();
                });
            },

            closeCreateCustomCounterDialog(){
                this.$refs.CreateCustomCounterDialog.close();
            },

            createCustomCounter(){
                const validateResult = this.$refs.createCustomCounterDialog.validateOfCreateCustomCounter();
                if (!validateResult) {
                    return;
                }

                const counterFormulaLength = this.$refs.createCustomCounterDialog.counterFormula.length;
                if(counterFormulaLength > 256){
                    EventBus.$emit('toast', {type: 'warning', content: `${this.$t('Pm.alertFormula4')}`});
                    return;
                }

                this.$loading.showLoadding(this.$t('System.loading'));
                this.$axios.post('/lte/ems/pm/gnb/counter/createCustomCounter.html', {
                    counterNameCH: this.$refs.createCustomCounterDialog.counterNameCH,
                    counterNameEN: this.$refs.createCustomCounterDialog.counterNameEN,
                    unit: this.$refs.createCustomCounterDialog.unit,
                    counterFormula: this.$refs.createCustomCounterDialog.counterFormula,
                    paramTypeCode: this.$refs.createCustomCounterDialog.paramTypeCode,
                    spaceCode: this.$refs.createCustomCounterDialog.spaceCode,
                }).then(response => {
                    this.$loading.hideLoadding();
                    this.$refs.CreateCustomCounterDialog.close();
                    if(response == null || response.status !== 200 || response.data == undefined){
                        EventBus.$emit('toast', {type: 'warning', content: `${this.$t('Pm.addCustomCounter')}${this.$t('Pm.fail')}`});
                    } else if (response.data.errorCode === 'SUCCESS'){
                        this.$refs.CustomCounterList.getCustomCounterList();
                        EventBus.$emit('toast', {type: 'success', content: `${this.$t('Pm.addCustomCounter')}${this.$t('Pm.success')}`});
                    } else{
                        EventBus.$emit('toast', {type: 'warning', content: response.data.errorCode});
                    }
                }).catch((error) => { // 请求失败处理
                    this.$loading.hideLoadding();
                    this.$refs.CreateCustomCounterDialog.close();
                    EventBus.$emit('toast', {type: 'warning', content: error});
                });

            },

            closeModifyCustomCounterDialog(){
                this.$refs.ModifyCustomCounterDialog.close();
            },

            modifyCustomCounter(){
                const validateResult = this.$refs.modifyCustomCounterDialog.validateOfModifyCustomCounter();
                if (!validateResult) {
                    return;
                }

                const counterFormulaLength = this.$refs.modifyCustomCounterDialog.counterFormula.length;
                if(counterFormulaLength > 256){
                    EventBus.$emit('toast', {type: 'warning', content: `${this.$t('Pm.alertFormula4')}`});
                    return;
                }

                this.$loading.showLoadding(this.$t('System.loading'));
                this.$axios.post('/lte/ems/pm/gnb/counter/modifyCustomCounter.html', {
                    counterNameCH: this.$refs.modifyCustomCounterDialog.counterNameCH,
                    counterNameEN: this.$refs.modifyCustomCounterDialog.counterNameEN,
                    unit: this.$refs.modifyCustomCounterDialog.unit,
                    counterFormula: this.$refs.modifyCustomCounterDialog.counterFormula,
                    paramTypeCode: this.$refs.modifyCustomCounterDialog.paramTypeCode,
                    spaceCode: this.$refs.modifyCustomCounterDialog.spaceCode,
                    counterCode: this.$refs.modifyCustomCounterDialog.counterCode
                }).then(response => {
                    console.log('refs',this.$refs);
                    console.log('this',this);
                    this.$loading.hideLoadding();
                    this.$refs.ModifyCustomCounterDialog.close();
                    if(response == null || response.status !== 200 || response.data == undefined){
                        EventBus.$emit('toast', {type: 'warning', content: `${this.$t('Pm.modCustomCounter')}${this.$t('Pm.fail')}`});
                    } else if (response.data.errorCode === 'SUCCESS'){
                        this.$refs.CustomCounterList.getCustomCounterList();
                        EventBus.$emit('toast', {type: 'success', content: `${this.$t('Pm.modCustomCounter')}${this.$t('Pm.success')}`});
                    } else{
                        EventBus.$emit('toast', {type: 'warning', content: response.data.errorCode});
                    }
                });
            }
        },

        mounted() {
        }
    };
</script>

<style scoped>
</style>
